import { getField, updateField } from 'vuex-map-fields';
import StorageService from '@/services/StorageService';
import LessonService from '@/services/LessonService';

const getDefaultState = function () {
    return {
        id: null,
        name: null,
        sortOrder: null,
        exerciseCategoryName: null,
        exerciseCategoryId: null,
        lawName: null,
        lawId: null,
        verdictSummaryName: null,
        verdictSummaryId: null,
        status: null
    };
};

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = getDefaultState();

const getters = {
    getField,
    form: (state) => ({
        id: state.id,
        name: state.name,
        sortOrder: state.sortOrder,
        exerciseCategoryName: state.exerciseCategoryName,
        exerciseCategoryId: state.exerciseCategoryId,
        lawName: state.lawName,
        lawId: state.lawId,
        verdictSummaryName: state.verdictSummaryName,
        verdictSummaryId: state.verdictSummaryId,
        status: state.status
    }),
};

const mutations = {
    setVerdict(state, value) {
        if (value) {
            // value.Transfers.forEach((status) => {
            //     status.Events.sort((a, b) => new Date(a.Date) - new Date(b.Date));
            // });
            Object.assign(state, value);
        } else {
            Object.assign(state, getDefaultState());
        }
    },

    storeReportDetails(state, data) {
        Object.assign(state, data);
    },
    updateField,
};

const actions = {
    async loadVerdict({ commit }, data) {
        const course = StorageService.getCourse();
        const res = await LessonService.getAdminVerdicts(course.id, {
            EntityId: data.id
        });
        commit('setVerdict', res.data.items[0]);
        return res.data;
    },
    async loadVerdictAdmin({ commit }, data) {
        const res = await LessonService.getReportAdmin(data.id);
        commit('setVerdict', res.data);
        return res.data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
